import React from 'react';
import { Card, CardContent } from '@mui/material';
import { Link } from 'gatsby';
import * as styles from './LessonCard.module.css';
import getAnonyUserId from '../services/getAnonyUserId';

const Redirecter = ({ urlSlug, contentful_id, children }) => {
  const userId = getAnonyUserId();
  const isBrowser = typeof window !== 'undefined';
  const passingSearch = isBrowser
    ? window.location.search.replace('?', '&')
    : '';
  const skipPhone =
    isBrowser && !!localStorage.getItem('phone_number')
      ? '&skipPhone=true'
      : '';

  if (urlSlug) {
    return <Link to={`/${urlSlug}`}>{children}</Link>;
  } else {
    return (
      <a
        href={`${process.env.GATSBY_APP_BASE_URL}/aula/${contentful_id}?utm_origin=SEO&utm_source=aula_similar_SEO&SEOID=${userId}${skipPhone}${passingSearch}`}
      >
        {children}
      </a>
    );
  }
};

const LessonCard = ({ lesson }) => {
  const { urlSlug, contentful_id, title, intro } = lesson;
  return (
    <Redirecter urlSlug={urlSlug} contentful_id={contentful_id}>
      <Card>
        <CardContent style={{ height: 240 }}>
          <h3 className={styles.cardTitle}>{title}</h3>
          <div
            style={{ fontSize: '0.875rem' }}
            dangerouslySetInnerHTML={{
              __html: intro?.childMarkdownRemark?.html,
            }}
          />
        </CardContent>
      </Card>
    </Redirecter>
  );
};

export default LessonCard;
